import { createVNode as _createVNode2 } from "vue";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-608eefd7"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "tree-wrapper__searchBtn__text"
}, "搜索文档", -1));

const _hoisted_2 = {
  class: "tree-wrapper__list"
};
import { ref, reactive, computed, watchEffect, h, nextTick, onMounted } from 'vue';
import { NTree, NScrollbar } from 'naive-ui';
import { useInfiniteScroll, useStorage } from '@vueuse/core';
import Icon from '@teams/common/components/icon';
import TreeItem from './treeItem.vue';
import { MENU_KEY_PREFIX } from '@teams/common/hooks/useTreeBase';
import useTreeFiles from '@/components/content/useTreeFiles';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    treeWideStore: null,
    groupId: null,
    fid: null
  },
  emits: ["postMessage", "changeDir", "entryTrash", "entrySearch", "startDragEvent", "endDragEvent"],

  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;

    _useCssVars(_ctx => ({
      "54c45d22": _unref(treeWide)
    }));

    const selectedKeys = ref([]);
    const listRef = ref(null); // eslint-disable-next-line @typescript-eslint/no-empty-function

    useInfiniteScroll(listRef, () => {}); // 节点是否加载完成

    const nodeLoadedStatus = reactive({});
    const expandedKeySet = ref(new Set([]));
    const expandedKeys = computed(() => {
      return Array.from(expandedKeySet.value);
    });
    const {
      init,
      topMenus,
      childrenMap,
      loadMoreChildren,
      refreshChildren,
      findNodeByKey,
      nodeManager
    } = useTreeFiles({
      nodeLoadedStatus,
      expandedKeys
    });
    const data = computed(() => {
      return topMenus;
    });
    watchEffect(async () => {
      const firstMenu = topMenus[0]; //  手动展开第一项

      if (firstMenu) {
        selectedKeys.value = [firstMenu.key];
        await nextTick();
        toggleExpand(firstMenu);
      }
    });

    const renderLabel = ({
      option
    }) => {
      return _createVNode2(TreeItem, {
        "option": option,
        "ref": "treeItemRef"
      }, null);
    };

    const renderSwitcherIcon = () => h(Icon, {
      name: 'treeArrow',
      class: 'tree-wrapper__switch__icon',
      size: 8
    }); // 加载子节点


    const handleLoad = async node => {
      await nodeManager.getChildren(node, {
        reset: true
      });
      nodeManager.setNodeChildren(node);
      nodeLoadedStatus[node.key] = true;
    };

    function removeExpandedKey(key) {
      if (!key || !childrenMap[key]) {
        return;
      }

      nodeLoadedStatus[key] = false;
      expandedKeySet.value.delete(key);
      const children = childrenMap[key].children;
      children && children.forEach(it => {
        removeExpandedKey(it.key);
      });
    }

    function removeChildren(node) {
      removeExpandedKey(node.key);
    }

    const toggleExpand = option => {
      const {
        key
      } = option;

      if (expandedKeySet.value.has(key)) {
        removeChildren(option);
      } else if (!option.isLoadMore) {
        expandedKeySet.value.add(key);
      }
    }; // 点击文件夹


    const goDetail = node => {
      emits('changeDir', node);
    };

    const nodeProps = ({
      option
    }) => {
      let timer;
      return {
        class: {
          'tree-wrapper__item': true
        },

        onClick(e) {
          if (option.isLoadMore) {
            return loadMoreChildren(option.parentKey);
          }

          clearTimeout(timer);
          let target = e.target;
          timer = setTimeout(() => {
            let isClickSwitchIcon = false; // 是否点击的展开图标

            while (target && !isClickSwitchIcon && !target.classList.contains('tree-wrapper__item')) {
              if (target.classList.contains('n-tree-node-switcher') || target.classList.contains('tree-wrapper__switch__icon')) {
                isClickSwitchIcon = true;
              } else {
                target = target.parentNode;
              }
            }

            if (isClickSwitchIcon) {
              toggleExpand(option);
            } else {
              selectedKeys.value = [option.key];
              goDetail(option);
            }
          }, 300);
        },

        // 双击切换展开/收起
        onDblclick() {
          if (option.isLoadMore) {
            return;
          }

          clearTimeout(timer);
          toggleExpand(option);
        }

      };
    }; // 回收站点击态 （暂时隐藏）


    const spacialId = {
      trash: 'trash'
    }; // 暂时隐藏
    // const clickRecycle = () => {
    //   selectedKeys.value = [spacialId.trash]
    //   emits('entryTrash')
    // }
    // 搜索

    const clickSearch = () => {
      const rootMenu = topMenus[0];
      emits('entrySearch', rootMenu);
    }; // 拖动目录宽度


    let treeWideState = useStorage(`folder_tree_width_${props.treeWideStore.groupId}_${props.treeWideStore.userId}`, {});
    const isDrag = ref(false);
    const currentWide = ref(treeWideState.value[`nid${props.treeWideStore.nid}`] ? treeWideState.value[`nid${props.treeWideStore.nid}`] : 260);
    const treeWide = computed(() => currentWide.value + 'px'); // v-bind当前宽度使用

    const mousedownEvent = e => {
      isDrag.value = true;
      emits('startDragEvent');
      const startX = e.clientX;
      const originWide = currentWide.value;

      const mousemoveEvent = e => {
        const moveX = e.clientX - startX;

        if (originWide + moveX > 450) {
          currentWide.value = 450;
        } else if (originWide + moveX < 260) {
          currentWide.value = 260;
        } else {
          currentWide.value = originWide + moveX;
        }
      };

      document.addEventListener('mousemove', mousemoveEvent);

      const fn = () => {
        isDrag.value = false;
        emits('endDragEvent');
        treeWideState = useStorage(`folder_tree_width_${props.treeWideStore.groupId}_${props.treeWideStore.userId}`, {});
        treeWideState.value[`nid${props.treeWideStore.nid}`] = currentWide.value;
        document.removeEventListener('mousemove', mousemoveEvent);
        document.removeEventListener('mouseup', fn);
      };

      document.addEventListener('mouseup', fn);
    };

    onMounted(() => {
      const {
        groupId,
        fid
      } = props;
      init({
        groupId,
        fid
      });
    });
    expose({
      pathChange(data) {
        const {
          type,
          fid,
          tid,
          key: pathKey
        } = data;
        let key;

        if (['enttrash'].includes(pathKey)) {
          key = spacialId.trash;
        } else if (type === 'folder') {
          key = MENU_KEY_PREFIX.folder + fid;
        } else {
          key = MENU_KEY_PREFIX.group + tid;
        }

        if (!selectedKeys.value.includes(key)) {
          selectedKeys.value = [key];
        }
      },

      // 刷新节点
      refreshMenu(data) {
        const {
          key = '',
          childKey = ''
        } = data;
        const [, prefix, fid] = key.match(/(\w+)_(\d+)/) || [];
        const [, childFid] = childKey.match(/_(\d+)/) || [];
        let nodeKey;
        let childNodeKey;

        if (fid) {
          nodeKey = MENU_KEY_PREFIX.folder + fid;

          if (prefix === 'group') {
            nodeKey = MENU_KEY_PREFIX.group + fid;
          }

          if (expandedKeySet.value.has(nodeKey)) {
            refreshChildren(nodeKey);
          }
        } // 如果是子节点变化，刷新父节点


        if (childFid) {
          childNodeKey = MENU_KEY_PREFIX.folder + childFid;
          const parentKey = findNodeByKey(childNodeKey)?.parentKey;

          if (parentKey && expandedKeySet.value.has(parentKey)) {
            refreshChildren(parentKey);
          }
        }
      },

      // 移除节点
      removeMenu(keys = []) {
        const list = keys.map(key => {
          const [, fid] = key.match(/_(\d+)/) || [];
          return MENU_KEY_PREFIX.folder + fid;
        });
        list.forEach(key => {
          const node = findNodeByKey(key);

          if (node) {
            removeChildren(node);
          }
        });
        nodeManager.remove(list);
      },

      // 重命名
      rename(data) {
        Object.keys(data).forEach(key => {
          const [, fid] = key.match(/_(\d+)/) || [];
          const nodeKey = MENU_KEY_PREFIX.folder + fid;
          nodeKey && nodeManager.rename(nodeKey, data[key].text);
        });
      }

    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "tree-wrapper",
        onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop", "prevent"]))
      }, [_createElementVNode("button", {
        class: "tree-wrapper__searchBtn",
        onClick: clickSearch
      }, [_createVNode(_unref(Icon), {
        name: "search",
        fill: "transparent"
      }), _hoisted_1]), _createVNode(_unref(NScrollbar), {
        ref_key: "listRef",
        ref: listRef,
        class: "tree-wrapper__scrollbar",
        trigger: "hover"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(NTree), {
          cancelable: false,
          "block-line": true,
          "expanded-keys": _unref(expandedKeys),
          "selected-keys": selectedKeys.value,
          data: _unref(data),
          "render-label": renderLabel,
          "on-load": handleLoad,
          "node-props": nodeProps,
          "render-switcher-icon": renderSwitcherIcon,
          animated: false
        }, null, 8, ["expanded-keys", "selected-keys", "data"])])]),
        _: 1
      }, 512), _createElementVNode("div", {
        class: _normalizeClass(["dragLine", isDrag.value ? 'dragLine__isDrag' : '']),
        onMousedown: mousedownEvent
      }, null, 34)], 32);
    };
  }

});